__turbopack_context__.v({
  "cardImage": "event-card-module-scss-module__J4qGTa__cardImage",
  "compact": "event-card-module-scss-module__J4qGTa__compact",
  "description": "event-card-module-scss-module__J4qGTa__description",
  "eventCard": "event-card-module-scss-module__J4qGTa__eventCard",
  "eventModeCard": "event-card-module-scss-module__J4qGTa__eventModeCard",
  "eventModeImageWrapper": "event-card-module-scss-module__J4qGTa__eventModeImageWrapper",
  "imageWrapper": "event-card-module-scss-module__J4qGTa__imageWrapper",
  "infoContainer": "event-card-module-scss-module__J4qGTa__infoContainer",
  "timeAndPlace": "event-card-module-scss-module__J4qGTa__timeAndPlace",
  "title": "event-card-module-scss-module__J4qGTa__title",
});
